import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import moment from "moment";
import tapIcon from "../../services/TapIcon";
import TapSelect from "../../components/ui/TapSelect";
import TapInput from "../../components/ui/TapInput";
import HttpAPICall from "../../services/HttpAPICall";
import Loader from "../../components/ui/Loader/Loader";
import { IAM_API_BASE_URL_2 } from "../../services/TapApiUrls";
import "react-datepicker/dist/react-datepicker.css";
import ApplicationLayout from "../../layouts/ApplicationLayout";
import { Helmet } from "react-helmet";
import GeneralSelectFor from "../../pages/includes/GeneralSelectFor";
import TapHelper from "../../services/TapHelper";
import axios from "axios";
import { Link } from "react-router-dom";
import InputVendorSearch from "../includes/ui/InputVendorSearch";

const CommonExpenseAddForm = (props) => {
    const accessToken = useSelector((state) => state.auth.access_token);
    const isEditMode = props.match?.params?.id || props.location?.state?.expenseDetailData;
    const editExpenseData = props.location?.state?.expenseDetailData || null;
    const editExpenseTicketData = props.editExpenseTicketData || null
    
    const isTicketExpense = !!props.ticketId;
    const initExpenseForm = {
        expense_date: moment(new Date()).format("YYYY-MM-DD"),
        expense_for: "",
        asset_id: "",
        workstation_id: "",
        employee_id: "",
        vendor_id: "",
        customer_id: "",
        sub_assembly_id: "",
        reference_number: "",
         site_id: "",   
        photo: null,
        details: "",
        amount: "",
    };

    const [loading, setLoading] = useState(false);
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [expenseForm, setExpenseForm] = useState({ ...initExpenseForm });
    const [expenseHeadOptions, setExpenseHeadOptions] = useState([]);
    const [paymentFromOptions, setPaymentFromOptions] = useState([]);
    const [expenseDetails, setExpenseDetails] = useState([{ head: null, amount: null }]);
    const [modalLoading, setModalLoading] = useState(true);
    const [searchedVendor, setSearchedVendor] = useState(null);

    const [forData, setForData] = useState({
        forField: ['asset', 'workstation', 'employee', 'sub_assembly', 'customer', 'site'],
        type: 'Expense For',
        warehouseSites: [],
        chageWarehouse: false,
        ticketSelected: false,
        isRequired: false,

        editData: {
            type: '',
            workstation_id: '',
            asset_id: '',
            employee_id: '',
            customer_id: '',
            sub_assembly_id: '',
            site_id: '' 
        }
    });

    useEffect(() => {
        fetchFormData();
    }, []);

    useEffect(() => {
        if (isEditMode && editExpenseData || editExpenseTicketData) {
            handleEditData(editExpenseData || editExpenseTicketData);
        }
    }, [isEditMode, editExpenseData ,editExpenseTicketData]);

    useEffect(() => {

        if (props.expenseForData) {
            setForData(prev => ({
                ...prev,
                ticketSelected: true,
                editData: props.expenseForData,
            }));
            handleAfterSelectForData(props.expenseForData);
        }
    }, [props.expenseForData]);

    const handleEditData = (data) => {
        const detail = data.detail || data;

        setExpenseForm({
            expense_date: detail.expense_date || moment(new Date()).format("YYYY-MM-DD"),
            expense_for: detail.expense_for || "",
            asset_id: detail.asset_profile?.asset_id || "",
            workstation_id: detail.workstation?.id || "",
            employee_id: detail.employee?.enc_id || "",
            vendor_id: detail.vendor?.id || "",
            customer_id: detail.customer?.id || "",
            sub_assembly_id: detail.sub_assembly?.enc_id || "",
            reference_number: detail.reference_number || "",
            photo: null,
            details: detail.notes || detail.details || "",
            amount: detail.amount || "",
            site_id: detail.site?.id || "", 
        });


        if (detail.vendor) {
            setSearchedVendor({
                value: detail.vendor.id,
                label: detail.vendor.name,
                display_label: `${detail.vendor.name} (${detail.vendor.code || ''})`
            });
        }

        if (detail.expense_detail && detail.expense_detail.length > 0) {
            setExpenseDetails(
                detail.expense_detail.map(item => ({
                    head: item.head,
                    amount: item.amount
                }))
            );
        }

        setForData(prev => ({
            ...prev,
            editData: {
                type: detail.expense_for || "",

                employee_id: detail.employee?.enc_id || "",
                selected_employee: detail.employee ? {
                    value: detail.employee.enc_id,
                    label: `${detail.employee.fname} ${detail.employee.lname || ""}`,
                    ...detail.employee
                } : null,

                customer_id: detail.customer?.id || "",
                selected_customer: detail.customer ? {
                    value: detail.customer.id,
                    label: detail.customer.name,
                    ...detail.customer
                } : null,

                asset_id: detail.asset_profile?.asset_id || "",
                selected_asset: detail.asset_profile ? {
                    value: detail.asset_profile.asset_id,
                    label: detail.asset_profile.name,
                    display_label: detail.asset_profile.name,
                    ...detail.asset_profile
                } : null,

                workstation_id: detail.workstation?.id || "",
                selected_workstation: detail.workstation ? {
                    value: detail.workstation.id,
                    label: detail.workstation.workstation_name,
                    ...detail.workstation
                } : null,
                selected_site: detail.site
                    ? {
                        value: detail.site.id,
                        label: detail.site.site_name,
                        ...detail.site,
                    }
                    : null,
                sub_assembly_id: detail.sub_assembly?.enc_id || "",
                selected_subassembly: detail.sub_assembly ? {
                    value: detail.sub_assembly.enc_id,
                    label: detail.sub_assembly.name,
                    ...detail.sub_assembly
                } : null,
                site_id: detail.site?.id || "",

                selected_site: detail.site
                    ? {
                        value: detail.site.id,
                        label: detail.site.site_name,
                        ...detail.site,
                    }
                    : null,
            }
        }));
    };

    const fetchFormData = () => {
        setModalLoading(true);
        HttpAPICall.withAthorization("GET", IAM_API_BASE_URL_2 + "/expense/form_data", accessToken, null, null,
            (response) => {
                const formData = response.data;
                setExpenseHeadOptions(formData.heads ? formData.heads.map((h) => ({ value: h.id, label: h.expense_head })) : []);
                setPaymentFromOptions(['Wallet1', 'Wallet2'].map((h) => ({ value: h, label: h })) || []);
                setModalLoading(false);
            },
            (error) => {
                setModalLoading(false);
                toast.error("Failed to load form data", { position: toast.POSITION.TOP_RIGHT });
            },
        );
    };

    const handleFormChange = ({ target: { name, value } }) => {
        setExpenseForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleDateChange = (value) => {
        const formattedDate = moment(value).format("YYYY-MM-DD");
        setExpenseForm({
            ...expenseForm,
            expense_date: formattedDate,
        });
    };

    const handleFileChange = (e) => {
        let file = e.target.files[0];
        if (file) {
            setExpenseForm({
                ...expenseForm,
                photo: file,
            });
        }
    };

    const handleAddExpenseDetail = () => {
        setExpenseDetails((prev) => [
            ...prev,
            { head: null, amount: null },
        ]);
    };

    const handlePaymentFrom = (field, value) => {
        setExpenseForm((prev) => ({
            ...prev,
            [field]: value,
        }));
    };
    const handleRemoveExpenseDetail = (index) => {
        if (expenseDetails.length > 1) {
            const updatedDetails = expenseDetails.filter((_, i) => i !== index);
            setExpenseDetails(updatedDetails);
        }
    };

    const handleExpenseDetailChange = (index, field, value) => {
        setExpenseDetails((prev) =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        );
    };


    const handleAfterSelectForData = (data) => {
        let workstation_id = '';
        let asset_id = '';
        let employee_id = '';
        let sub_assembly_id = '';
        let customer_id = '';
        let site_id = '';

        if (data && data.type) {
            switch (data.type) {
                case 'asset':
                    asset_id = data.asset_id;
                    break;

                case 'workstation':
                    workstation_id = data.workstation_id;
                    break;

                case 'employee':
                    employee_id = data.employee_id;
                    break;

                case 'sub_assembly':
                    sub_assembly_id = data.sub_assembly_id;
                    break;

                case 'customer':
                    customer_id = data.customer_id;
                    break;
                case 'site':
                    site_id = data.site_id;
                    break;
                default:
                    break;
            }
        }

        setExpenseForm((prev) => ({
            ...prev,
            expense_for: data?.type || "",
            asset_id,
            workstation_id,
            employee_id,
            sub_assembly_id,
            customer_id,
            site_id,
        }));
    };

    const closeEvent = () => {
        if (isEditMode || editExpenseTicketData) {
            props.history.push({
                pathname: "/expense_list/" + props?.match?.params?.id,
            });
        }
        else{
              props.history.push({
                pathname: "/expense_list" ,
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormSubmitting(true);

        const formData = new FormData();
        if (isEditMode || editExpenseData || editExpenseTicketData) {
            formData.append('transaction_id', editExpenseData?.detail?.transaction_id || editExpenseData?.transaction_id || editExpenseTicketData?.transaction_id || props.match?.params?.id);
        }
        if (props.editData?.transaction_id) {
            formData.append("transaction_id", props.editData.transaction_id);
        }
        formData.append('expense_date', expenseForm.expense_date);
        if (expenseForm.details) formData.append('details', expenseForm.details);
        if (expenseForm.expense_for) formData.append('expense_for', expenseForm.expense_for);
        if (expenseForm.asset_id) formData.append('asset_id', expenseForm.asset_id);
        if (expenseForm.workstation_id) formData.append('workstation_id', expenseForm.workstation_id);
        if (expenseForm.employee_id) formData.append('employee_id', expenseForm.employee_id);
        if (expenseForm.vendor_id) formData.append('vendor_id', expenseForm.vendor_id);
        if (expenseForm.customer_id) formData.append('customer_id', expenseForm.customer_id);
        if (expenseForm.site_id) formData.append('site_id', expenseForm.site_id);
        if (expenseForm.sub_assembly_id) formData.append('sub_assembly_id', expenseForm.sub_assembly_id);
        if (expenseForm.reference_number) formData.append('reference_number', expenseForm.reference_number);
        if (expenseForm.photo) formData.append('photo', expenseForm.photo);
        const totalAmount = TapHelper.arraySumByKey(expenseDetails, 'amount') || 0;
        formData.append('amount', totalAmount);
        const validExpenseDetails = expenseDetails.filter(detail => detail.head && detail.amount > 0).map(detail => ({
            head: detail.head,
            amount: detail.amount
        }));
        formData.append("expense_detail", JSON.stringify(validExpenseDetails));
        if (props.ticketId) {
            formData.append("ticket_id", props.ticketId);
        }
        if (props.counterlogTransactionId) {
            formData.append(
                "counterlog_transaction_id",
                props.counterlogTransactionId
            );
        }
        const url = isEditMode || editExpenseTicketData
            ? IAM_API_BASE_URL_2 + "/expense/edit"
            : IAM_API_BASE_URL_2 + "/expense/add";

        axios({
            method: "POST",
            url: url,
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            data: formData,
        }).then((res) => {
            toast.success(res?.data?.msg || `Expense ${isEditMode || editExpenseTicketData ? 'updated' : 'saved'} successfully`, {
                position: toast.POSITION.TOP_RIGHT,
            });
            if (props.onSuccess) {
                props.onSuccess(res);
                resetForm();

            } else {
                resetForm();
                closeEvent();
            }
            setFormSubmitting(false);
        })
            .catch((err) => {
                setFormSubmitting(false);
                toast.error(err?.response?.data?.msg || err?.message || "Something went wrong", {
                    position: toast.POSITION.TOP_RIGHT
                });
            });
    };

    const resetForm = () => {
        setExpenseForm({ ...initExpenseForm });
        setExpenseDetails([{ head: null, amount: null }]);
        setSearchedVendor(null);
        setForData(prev => ({
            ...prev,
            editData: {
                type: '',
                asset_id: '',
                workstation_id: '',
                employee_id: '',
                customer_id: '',
                sub_assembly_id: '',
                 site_id: ''
            }
        }));
    };
    const saveExpenseFormJsx = () => {
        const totalAmount = TapHelper.arraySumByKey(expenseDetails, 'amount') || 0;

        return (
            <div className="expense-add-container">
                {modalLoading || loading ? (
                    <Loader />
                ) : (
                    <form className={`bg-white ${props?.showModalData || props.showLogSheetModalData ? "" : "p-3"}`} onSubmit={handleSubmit}>
                        <div className="row mb-3">
                            <GeneralSelectFor
                                forData={forData}
                                afterSelectForData={handleAfterSelectForData}
                                labelClass="col-sm-3"
                                inputClass="col-sm-4"
                                labelClass2="col-sm-3"
                                editData={forData.editData}
                                disabled={props.showModalData || props.showLogSheetModalData}
                            />
                        </div>

                        <div className="tab_content_wrapper mb-3">
                            <span className="content_heading">Expense Details</span>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <label className="col-sm-3 col-form-label text-left require">
                                Expense Date
                            </label>
                            <div className="col-sm-4 add_calender_section">
                                <DatePicker
                                    selected={
                                        expenseForm.expense_date
                                            ? moment(expenseForm.expense_date, "YYYY-MM-DD").toDate()
                                            : null
                                    }
                                    onChange={handleDateChange}
                                    maxDate={moment(new Date()).toDate()}
                                    dateFormat="dd-MMM-yyyy"
                                    className="form-control"
                                    showMonthDropdown
                                    showYearDropdown
                                    autoComplete="off"
                                    required
                                    placeholderText="Select Date"
                                />
                                <tapIcon.imageIcon
                                    icon={tapIcon.CalenderIcon}
                                    alt="expense_date"
                                    className="add_calender-icon"
                                />
                            </div>
                        </div>
                        <div className="row my-3 align-items-center">
                            {expenseDetails.map((detail, index) => (
                                <>
                                    <label className={`col-sm-3 col-form-label text-left mb-2 ${index === 0 ? "require" : ""}`}>
                                        {index === 0 ? "Expense Head" : ""}
                                    </label>
                                    <div className="col-sm-4 mb-2">
                                        <TapSelect
                                            options={expenseHeadOptions.filter(option => {
                                                const selectedHeads = expenseDetails
                                                    .filter((_, i) => i !== index)
                                                    .map(item => item.head);
                                                return (
                                                    !selectedHeads.includes(option.value) ||
                                                    option.value === detail.head
                                                );
                                            })}
                                            changeEvent={(selectedOption) => {
                                                handleExpenseDetailChange(index, "head", selectedOption?.value || null);
                                            }}
                                            value={expenseHeadOptions.find((s) => s.value === detail.head)}
                                            required
                                            placeholder="Select Head"
                                        />
                                    </div>
                                    <div className="col-sm-3 mb-2">
                                        <TapInput
                                            className="form-control"
                                            value={detail.amount || ""}
                                            placeholder="Expense Amount"
                                            required={true}
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            autoComplete="off"
                                            onChange={(e) => {
                                                handleExpenseDetailChange(index, 'amount', e.target.value);
                                            }}
                                        />
                                    </div>
                                    {index > 0 && (
                                        <div className="col-sm-1 text-end">
                                            <Link
                                                className="d-block my-2 text-secondary"
                                                onClick={() => handleRemoveExpenseDetail(index)}
                                                style={{ color: "#6c757d", fontWeight: "500", fontSize: "17px", cursor: "pointer" }}
                                            >
                                                ✕
                                            </Link>
                                        </div>
                                    )}

                                </>
                            ))}
                            <div className="col-sm-1 text-start">
                                <Link
                                    className="d-block my-2 text-secondary"
                                    onClick={handleAddExpenseDetail}
                                    style={{ color: "#6c757d", fontWeight: "500", fontSize: "17px", cursor: "pointer" }}
                                >
                                    <tapIcon.FontAwesomeIcon
                                        icon={tapIcon.faPlus}
                                        className="img-fluid"
                                        alt="add-expense-head"
                                    />
                                </Link>
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <label className="col-sm-3 col-form-label text-left require">
                                Total Expense Amount
                            </label>
                            <div className="col-sm-4">
                                <TapInput
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Total Expense Amount"
                                    value={totalAmount || 0}
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="row mb-2 mt-1">
                            <label className="col-sm-3 col-form-label col-form-label-sm ">Vendor</label>
                            <div className="col-sm-4">
                                <InputVendorSearch
                                    changeEvent={(selectedOption) => {
                                        setSearchedVendor(selectedOption || null);
                                        setExpenseForm((prev) => ({
                                            ...prev,
                                            vendor_id: selectedOption ? selectedOption.value : '',
                                        }));
                                    }}
                                    value={searchedVendor}
                                    placeholder="Search Vendor"
                                />
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <label className="col-sm-3 col-form-label text-left">
                                Reference Number
                            </label>
                            <div className="col-sm-4">
                                <TapInput
                                    className="form-control"
                                    name="reference_number"
                                    autoComplete="off"
                                    value={expenseForm.reference_number}
                                    onChange={handleFormChange}
                                    placeholder="Please Enter Ref Number"
                                />
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <label className="col-sm-3 col-form-label text-left">
                                Upload Document
                            </label>
                            <div className="col-sm-4">
                                <input
                                    onChange={handleFileChange}
                                    type="file"
                                    name="photo"
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Please upload document"
                                />
                            </div>
                        </div>

                        <div className="row mb-3 align-items-center">
                            <label className="col-sm-3 col-form-label text-left">
                                Expense Details
                            </label>
                            <div className="col-sm-4">
                                <textarea
                                    className="form-control"
                                    name="details"
                                    value={expenseForm.details}
                                    onChange={handleFormChange}
                                    style={{ height: "60px", fontSize: "93%" }}
                                    placeholder="Enter Expense Details"
                                />
                            </div>
                        </div>
                        <div className="row me-5">
                            <div className="col-sm-12 text-end mb-2">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={formSubmitting}
                                >
                                    Save
                                    {formSubmitting && (
                                        <tapIcon.FontAwesomeIcon
                                            icon={tapIcon.faSyncAlt}
                                            className="fa-spin"
                                        />
                                    )}
                                </button>
                            </div>
                        </div>
                    </form>
                )}
            </div>
        );
    };

    return (
        <>
            {
                props?.showModalData || props.showLogSheetModalData
                    ?
                    loading || modalLoading ? <Loader /> : saveExpenseFormJsx()
                    :
                    <>
                        <Helmet>
                            <title>{isEditMode || editExpenseTicketData ? 'Edit Expense' : 'Add New Expense'}</title>
                        </Helmet>
                        <div className="page_title row m0">
                            <div className="col-12">
                                <h3>{isEditMode || editExpenseTicketData ? 'Edit Expense' : 'Add New Expense'}</h3>
                                <div className="text-end mt15">
                                    <button
                                        onClick={closeEvent}
                                        disabled={formSubmitting}
                                        type="button"
                                        className="btn btn-secondary"
                                    >
                                        <tapIcon.imageIcon
                                            icon={tapIcon.CloseIcon}
                                            className="img-fluid"
                                            alt="Close Expense"
                                        />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="page_containt row pl2">
                                <div className="pageTbl col-12 pl4">
                                    {loading || modalLoading ? <Loader /> : saveExpenseFormJsx()}
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>
    );
};

export default CommonExpenseAddForm;